module.exports = __webpack_public_path__ + "img/upload.da5b444.png";